// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { xScreen } from "@plumberssupply/XDL/Utilities";
import { mergeWithCss } from "@plumberssupply/XDL/Utilities/mergeWithCss";
import React, { useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    extendedStyles?: StyledBoxStyles;
}

export interface StyledBoxStyles {
    container?: InjectableCss;
}

export const styledBoxStyle = css`
    padding: 15px;
    background: ${getColor("common.white")};
    border: 1px solid ${getColor("common.ui5")};
    ${xScreen("lte", "sm")} {
        margin-bottom : 13px;
    }
`;

const styledBoxStyles: StyledBoxStyles = {
    container: {
        css: css`
            ${styledBoxStyle}
        `,
    },
};

const StyledBox: React.FC<OwnProps> = ({ children, extendedStyles }) => {
    const [styles] = useState(() => mergeWithCss(styledBoxStyles, extendedStyles));

    if (!React.Children.count(children)) {
        return null;
    }

    return (
        <StyledWrapper {...styles.container} data-test-selector="styled-box">
            {children}
        </StyledWrapper>
    );
};

export default StyledBox;
